export default __webpack_public_path__ + "static/media/work-sans-v11-latin-regular.ab561f71.eot";